import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class Newsletter extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.email = '';
    this.busy = false;
    this.success = false;
  }
  async submit(event) {
    event.preventDefault();
    if (this.busy) return;
    this.busy = true;
    try {
      await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/devconnect/newsletter`,
        body: {
          email: this.email
        }
      });
      this.success = true;
      this.email = '';
    } catch (error) {
      app.alerts.show({
        type: 'error'
      }, 'Не удалось оформить подписку. Проверьте адрес и попробуйте ещё раз.');
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
  view() {
    return m('section.dc-section.dc-section--tight', m('div.dc-container', m('div.dc-news.dc-card', [m('div.dc-news__body', [m('h2', 'Будьте в курсе важного'), m('p', 'Лучшие статьи и обсуждения DevConnect — без спама. Одно письмо в неделю.')]), m('div.dc-news__form', this.success ? m('div.dc-news__success', '✓ Готово! Подтверждение отправлено на вашу почту.') : [m('form', {
      onsubmit: this.submit.bind(this)
    }, [m('input', {
      type: 'email',
      placeholder: 'Ваш e-mail',
      autocomplete: 'email',
      required: true,
      value: this.email,
      oninput: event => {
        this.email = event.target.value;
      }
    }), m('button.dc-btn.dc-btn--primary', {
      type: 'submit',
      disabled: this.busy
    }, this.busy ? 'Отправляем…' : 'Подписаться')]), m('small', 'Отписаться можно в любой момент.')])])));
  }
}
flarum.reg.add('devconnect-portal', 'forum/components/Newsletter', Newsletter);